import { useMemo } from 'react';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { useIntl } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { CsvColumnSearchableDropdown } from './csv-column-searchable-dropdown';
import { WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {import('../../../data/types/types').TemplateAttribute} props.templateAttribute
 * @param {import('../../../data/types/types').MappedColumn} props.csvColumn
 * @returns {React.JSX.Element}
 */
export const SelectCsvColumn = ({ templateAttribute, csvColumn }) => {
  const { definition, updateMapping, getMappingErrors, trackProcess } = useImportContext();

  const intl = useIntl();
  const mappingErrors = getMappingErrors(templateAttribute.code);

  const changeMapping = (newValue) => {
    updateMapping(templateAttribute, newValue);
    trackProcess(WorkflowSteps.CSV_IMPORT_CHANGE_MAPPING_FIELD, {
      ssField: templateAttribute.code,
      csvColumn: newValue,
    });
  };

  const dropdownOptions = useMemo(() => {
    const defaultOption = {
      text: intl.formatMessage(messages.doNotImport),
      value: '',
      isDefault: true,
      icon: faBan,
    };
    return definition.columns.reduce(
      (acc, column) => {
        acc.push({ value: column, text: column });
        return acc;
      },
      [defaultOption],
    );
  }, [definition.columns, intl]);

  const inlineMessage = mappingErrors?.length ? (
    <ul>
      {mappingErrors.map((error) => (
        <Text
          key={error.attributeCode}
          className={styles['error-message']}
          element='li'
          textType={TextType.Caption}
          value={error.message}
        />
      ))}
    </ul>
  ) : null;

  return (
    <CsvColumnSearchableDropdown
      inlineMessage={inlineMessage}
      onOptionSelected={changeMapping}
      options={dropdownOptions}
      selectedOptionValue={csvColumn.csvColumn}
    />
  );
};
